import { mapState } from 'vuex'
import TheBreadcrumbs from '@/components/common/TheBreadcrumbs/TheBreadcrumbs'
import DataTable from '@/components/common/DataTable/DataTable'
import _ from 'lodash'

export default {
  name: 'PageNewsList',
  layout: 'LayoutDefault',
  components: {
    TheBreadcrumbs: TheBreadcrumbs,
    DataTable: DataTable
  },
  data: () => ({
    breadcrumbs: [
      {
        text: 'ダッシュボード',
        disabled: false,
        href: '/'
      },
      {
        text: 'お知らせ一覧',
        disabled: true,
        href: ''
      }
    ],
    searchWord: '',
    contractId: 0,
    selectionState: { selectedCount: 0, disableAllSelected: true }
  }),
  created () {
    console.log('NewsList created')
    this.getContracts()
  },
  computed: {
    ...mapState({
      list: state => state.pagenewslist.list
    }),
    ...mapState('pageaddnews', {
      noticeItem: state => state.noticeItem,
      contractList: state => state.contractList
    })
  },
  methods: {
    onSelectionChanged (selection, disableAllSelected) {
      this.selectionState = {
        selectedCount: selection.length,
        disableAllSelected: disableAllSelected
      }
    },
    updateSearch () {
      var contractId = null
      if (this.contractId != null) {
        contractId = this.contractId.value
      }
      this.getNewsData(
        1,
        null,
        null,
        this.searchWord,
        contractId
      )
    },
    getNewsData (pageNo, sortField, sortType, freeword, contractId) {
      this.$store.dispatch('pagenewslist/getNewsData', {
        pageNo: pageNo,
        sortField: sortField,
        sortType: sortType,
        freeword: freeword,
        contractId: contractId
      })
    },
    getContracts () {
      this.$store.dispatch('pageaddnews/getContractList', {
        pageNo: 0,
        sortField: null,
        sortType: 'created',
        freeword: null,
        isFirst: false
      })
    },
    onPagination (pagination) {
      var contractId = null
      if (this.contractId != null) {
        contractId = this.contractId.value
      }
      this.getNewsData(
        pagination.page,
        pagination.sortBy,
        pagination.descending,
        this.searchWord,
        contractId
      )
    },
    onSearch () {
      this.updateSearch()
    },
    onAddNews () {
      this.$router.push({ name: 'PageAddNews' })
    },
    onEdit (item) {
      this.$store.dispatch('pageaddnews/editNoticeItem', item)
      this.$router.push('/admin/notice/edit/' + item.id)
    },
    onCopy (item) {
      this.$store.dispatch('pageaddnews/editNoticeItem', item)
      this.$router.push({ name: 'PageAddNews' })
    },
    onDeleteItems (items) {
      let deleteIds = _.map(items, 'id')
      this.$store.dispatch('pagenewslist/doDelete', deleteIds)
    }
  },
  metaInfo () {
    this.$store.dispatch('meta/set', {
      title: 'お知らせ一覧',
      meta: [
        {
          name: 'description',
          content: 'お知らせ一覧'
        }
      ]
    })
    return this.$store.getters['meta/get']
  }
}
